import React, { Suspense } from 'react';
import { useSessionStorage } from 'react-use';

import {
  AutoModalPriority,
  useAutoModal,
} from '../../common/AutoModalProvider';
import useGetFeatureCount from '../../common/hooks/useGetFeatureCount';
import { useGetSessionCompany } from '../../common/hooks/useGetSessionCompany';
import ErrorBoundaryWithCrashReporting from '../Error/ErrorBoundaryWithCrashReporting';

const CompanyFullProfileAccessLimitReachedModal = React.lazy(
  () => import('./CompanyFullProfileAccessLimitReachedModal')
);

const MODAL_CLOSED_KEY = 'companyFullProfileAccessLimitModalClosed';

type ModalClosedByCompany = Record<string, true | undefined>;

export default function RenderCompanyFullProfileAccessLimitReachedModal() {
  const { sessionCompany } = useGetSessionCompany();
  const [modalClosedByCompany, setModalClosedByCompany] =
    useSessionStorage<ModalClosedByCompany>(MODAL_CLOSED_KEY);
  const isClosed = sessionCompany?.id
    ? Boolean(modalClosedByCompany?.[sessionCompany.id])
    : false;
  const { isShortListLimited, isMonthlyShortlistLimited } =
    useGetFeatureCount();
  const canShow = useAutoModal(
    AutoModalPriority.Reminder,
    !isClosed && isShortListLimited && !isMonthlyShortlistLimited
  );

  function handleClose() {
    if (!sessionCompany?.id) {
      return;
    }

    setModalClosedByCompany({
      ...modalClosedByCompany,
      [sessionCompany.id]: true,
    });
  }

  if (!canShow) {
    return null;
  }

  return (
    <ErrorBoundaryWithCrashReporting fallback={null}>
      <Suspense fallback={null}>
        <CompanyFullProfileAccessLimitReachedModal onClose={handleClose} />
      </Suspense>
    </ErrorBoundaryWithCrashReporting>
  );
}
